import "./Customizer.css"
import {flushSync} from "react-dom"
import {useNavigate, Link, useParams} from "react-router-dom"
// import { useHistory } from 'react-router-dom';
import React, {useCallback, useEffect, useRef, useState} from "react";
import {motion} from "framer-motion";
import {
    EditorTabs,
    fadeAnimation,
    slideAnimation,
    slideAnimation2,
    slideAnimation3,
    slideAnimation4, slideAnimation5
} from "../../components/HomeBackground/systems/constants";
// import CustomButton from "./CustomButton.jsx";
import {ColorPicker, CustomButton, Tab} from './components';
import state from "../../components/store/index.js";
import ToolSelectorTop from "./components/ToolSelectorTop/ToolSelectorTop.jsx";
import ToolSelectorLeft from "./components/ToolSelectorLeft/ToolSelectorLeft.jsx";
import LeftToolbar from "./components/ToolSelectorLeft/LeftToolbar.jsx";
import EditorSVG from "./components/components/EditorSVG.jsx";
import {FabricJSCanvas, useFabricJSEditor} from "../../fabricjs/index.jsx";
import {normalizePersistedBaseLayoutDimensions} from "../../fabricjs/baseLayoutDimensions.js";
import {buildBaseLayout} from "./SVGBaseLayouts/SVGBaseLayouts.jsx";
import {
    DEFAULT_PRODUCT,
    are3dParametersEqual,
    buildDefaultDesignName,
    get3dParameterSnapshot,
    getProduct,
    resolveProductType,
    withProductDefaults,
} from "../../products/registry";
import ToolSelectorRight from "./components/ToolSelectorRight/ToolSelectorRight.jsx";
import ViewportDock from "./components/ViewportDock/ViewportDock.jsx";
import ExploradorMedios from "../Profile/pages/Medios/ExploradorMedios/ExploradorMedios.jsx";
import axios from "axios";
import SelectedTypeProvider, {
    useEditorTypeRightContext,
    useEditorTypeRightToggleContext,
    useSelectedTypeContext,
    useSelectedTypeToggleContext
} from "./SelectedTypeProvider.jsx";
import ToolProvider from "./ToolProvider.jsx";
import Viewer2 from "./Editor3D/Viewer2.jsx";
import { hasSeparableParts } from "./Editor3D/partsLayout.js";
import ARViewer from "./AR/ARViewer.jsx";
import DataProvider, {
    useDataModelo3dContext,
    useDataModelo3dToggleContext,
    useOffsetLengthContext
} from "./DataProvider.jsx";
import {IconHome} from "./components/ToolSelectorTop/Icons.jsx";

import "./components/ToolSelectorRight/components/TextEditor/TextEditor.css"
import ToolsActionsGeneral from "./components/ToolsOnCorner/ToolsActionsGeneral.jsx";
import {getThemeContext} from "../../components/providers/ThemeProvider.jsx";
import {showAlert, showConfirm} from "../../components/HelperAlerts/HelpersAlerts.jsx";
import {toast} from "react-toastify";
import EditableTitle from "../../components/ui/EditableTitle.jsx";
import useVisualViewport from "../../components/hooks/useVisualViewport.js";
import useAutoSavePreference from "../../components/hooks/useAutoSavePreference.js";
import useMediaQuery from "../../components/tools/useMediaQuery.jsx";

const getBaseLayoutErrorMessage = (error) => {
    const responseData = error?.response?.data;

    if (typeof responseData === "string") return responseData;
    if (typeof responseData?.detail === "string") return responseData.detail;
    if (typeof responseData?.error === "string") return responseData.error;

    return error?.message || "No se pudo calcular la forma. Revisa la conexion con el backend.";
}

const areColorMapsEqual = (first = {}, second = {}) => (
    JSON.stringify(first) === JSON.stringify(second)
)


// Flecha -> dirección en el lienzo (la Y crece hacia abajo).
const NUDGE_DIRECTIONS = {
    ArrowLeft: [-1, 0],
    ArrowRight: [1, 0],
    ArrowUp: [0, -1],
    ArrowDown: [0, 1],
};

function Customizer({ productType = DEFAULT_PRODUCT }) {

    const { modelId } = useParams();
    // Which product's parameters, layouts and panels apply. The 2D editor itself
    // is shared; only the 3D interpretation of the roles differs.
    const product = getProduct(productType);
    // const [ editorTypeRight, setEditorTypeRight ] = useState(null);

    // contesto para controlar el editor de la derecha
    const editorTypeRight = useEditorTypeRightContext()
    const setEditorTypeRight = useEditorTypeRightToggleContext()
    const { keyboardOpen } = useVisualViewport()
    const isCoarsePointer = useMediaQuery("(pointer: coarse)")
    const isTouchViewport = useMediaQuery("(hover: none)")
    const isMobilePortrait = useMediaQuery("(orientation: portrait) and (max-width: 1024px)")
    const shouldShowPortraitNotice = (isCoarsePointer || isTouchViewport) && isMobilePortrait
    const editorTypeRightRef = useRef(editorTypeRight)
    const keyboardOpenRef = useRef(keyboardOpen)

    useEffect(() => {
        editorTypeRightRef.current = editorTypeRight
    }, [editorTypeRight])

    useEffect(() => {
        keyboardOpenRef.current = keyboardOpen
    }, [keyboardOpen])



    //contexto para el json del 2d
    const dataModelo3d = useDataModelo3dContext()
    const setDataModelo3d = useDataModelo3dToggleContext()

    //Contexto para saber el offset.
    const offsetLength = useOffsetLengthContext()
    const [baseLayoutActionState, setBaseLayoutActionState] = useState({
        loading: false,
        action: null,
        error: null,
    })
    const [resizeDrawingsWithBase, setResizeDrawingsWithBase] = useState(false)
    const nextBaseSizeResizeIncludesDrawings = useRef(false)
    const generatedBaseSize = useRef(null)
    const [manifoldPocState, setManifoldPocState] = useState({
        loading: false,
        result: null,
        error: null,
    })

    const [urlSTL, setUrlSTL] = useState(null);
    const [applied3dParameters, setApplied3dParameters] = useState(null)
    const [viewerRevision, setViewerRevision] = useState(0)
    // Cámara del visor 3D entre recargas: Viewer2 se remonta en cada revisión
    // y la guarda aquí para que el encuadre salga de donde estaba (C3D-29).
    const viewerCameraPoseRef = useRef(null)
    // Dos fases separadas para que la vista 3D muestre un estado claro:
    //  - isGeneratingFile: el backend está construyendo el GLB (POST regenerate-3d)
    //  - isViewerLoading: el GLB ya existe y el visor lo está descargando/decodificando
    const [isGeneratingFile, setIsGeneratingFile] = useState(false)
    const [isViewerLoading, setIsViewerLoading] = useState(false)
    const isRegenerating3d = isGeneratingFile || isViewerLoading
    // El indicador de estado vive en la barra superior (ToolSelectorTop), en el
    // mismo hueco que el badge de "Modelo 3D actualizado".
    const regenerationPhase = isGeneratingFile ? 'generating' : (isViewerLoading ? 'loading' : null)
    const generationStartRef = useRef(null)
    const [generationDuration, setGenerationDuration] = useState(null)

    // Piezas del modelo 3D y su visibilidad (panel "Piezas del modelo").
    const [modelParts, setModelParts] = useState([])
    const [partsVisibility, setPartsVisibility] = useState({})
    // Cómo se muestran las piezas imprimibles: ensambladas, la tapa levantada,
    // o una al lado de la otra para revisarlas antes de generar el 3MF.
    const [partsLayout, setPartsLayout] = useState('assembled')
    const [separationMm, setSeparationMm] = useState(45)
    // Seccionado: un plano horizontal que corta la pieza para ver su interior.
    // Como las disposiciones de arriba, es solo una vista — no cambia el modelo
    // ni lo que se imprime, así que no viaja al backend ni se guarda.
    const [sectionEnabled, setSectionEnabled] = useState(false)
    const [sectionHeightPct, setSectionHeightPct] = useState(50)
    const [sectionKeep, setSectionKeep] = useState('bottom')
    const [isGridVisible3d, setIsGridVisible3d] = useState(true)
    // Posición en la que se mira la pieza en 3D (C3D-8); solo es de la vista.
    const [viewOrientation3d, setViewOrientation3d] = useState('flat')
    const [partsColors, setPartsColors] = useState({})
    const [savedPartsColors, setSavedPartsColors] = useState({})
    const [isSavingPartsColors, setIsSavingPartsColors] = useState(false)
    const dataModelo3dRef = useRef(dataModelo3d)
    const skipNextParamsSaveRef = useRef(false)
    const withManifoldEngine = useCallback((formData = {}) => ({
        ...formData,
        stackedTopEngine: 'manifoldcad',
    }), [])

    useEffect(() => {
        dataModelo3dRef.current = dataModelo3d
    }, [dataModelo3d])

    const handlePartsLoaded = useCallback((rawParts) => {
        const storedColors = dataModelo3dRef.current?.partColors3d || {}
        // Una malla con objeto (C3D-22) se nombra por lo que es en 2D: el texto
        // que dice, o qué tipo de forma es. Si el objeto ya no está en el lienzo
        // se trata como una malla antigua, por color.
        const parts = rawParts.map(part => {
            const objectLabel = part.objectUid
                ? editorRef.current?.getPartObjectLabel(part.objectUid)
                : null
            return objectLabel ? { ...part, objectLabel } : { ...part, objectUid: null }
        })
        setModelParts(parts)
        // Al (re)cargar el modelo todas las piezas arrancan visibles.
        setPartsVisibility(Object.fromEntries(parts.map(p => [p.id, true])))
        const loadedColors = Object.fromEntries(parts.map(part => [
            part.key,
            storedColors[part.key] || part.colorHex || '#888888',
        ]))
        setPartsColors(loadedColors)
        setSavedPartsColors(loadedColors)
        parts.forEach(part => {
            const storedColor = storedColors[part.key]
            if (storedColor && part.sourceColor) {
                editorRef.current?.replaceFillColor(part.sourceColor, storedColor, {
                    backgroundOnly: part.isBackground,
                    objectUid: part.objectUid,
                })
            }
        })
    }, [])

    // Repinta una o varias piezas. Una pieza con objeto cambia sólo ese objeto
    // en 2D (y las demás mallas suyas de ese color, p. ej. a otra profundidad);
    // una sin objeto (fondo, diseños generados antes de C3D-22) cambia su color
    // en todo el lienzo, como siempre.
    const changePartsColor = useCallback((targets, color) => {
        setPartsColors(prev => {
            const next = { ...prev }
            const label = targets.length === 1
                ? `Color de ${targets[0].objectLabel || targets[0].name || 'pieza'} cambiado`
                : 'Color del grupo cambiado'
            targets.forEach((part, index) => {
                const previousColor = prev[part.key] || part.sourceColor || part.colorHex
                editorRef.current?.replaceFillColor(previousColor, color, {
                    backgroundOnly: part.isBackground,
                    objectUid: part.objectUid,
                    // Una sola foto del historial por cambio, no una por pieza.
                    historyLabel: index === targets.length - 1 ? label : null,
                })
                modelParts.forEach(candidate => {
                    const candidateColor = prev[candidate.key] || candidate.sourceColor || candidate.colorHex
                    if (
                        candidate.isBackground === part.isBackground
                        && candidate.objectUid === part.objectUid
                        && candidateColor?.toLowerCase() === previousColor?.toLowerCase()
                    ) {
                        next[candidate.key] = color
                    }
                })
            })
            return next
        })
    }, [modelParts])

    const changePartColor = useCallback((part, color) => changePartsColor([part], color), [changePartsColor])

    const togglePartVisibility = useCallback((id) => {
        setPartsVisibility(prev => {
            const isVisible = prev[id] !== false
            return { ...prev, [id]: !isVisible }
        })
    }, [])

    const showAllParts = useCallback(() => {
        setPartsVisibility(Object.fromEntries(modelParts.map(p => [p.id, true])))
    }, [modelParts])

    const soloPart = useCallback((id) => {
        setPartsVisibility(Object.fromEntries(modelParts.map(p => [p.id, p.id === id])))
    }, [modelParts])

    const savePartsColors = async () => {
        const currentModelId = modelo3dRef.current?.id
        if (!currentModelId || isSavingPartsColors || areColorMapsEqual(partsColors, savedPartsColors)) return

        const liveCanvas = editor?.canvas
        if (!liveCanvas || liveCanvas.disposed || liveCanvas.getObjects().length === 0) {
            showAlert({
                title: 'No se guardaron los colores',
                text: 'El diseño 2D no está disponible. Vuelve a 2D y recarga el modelo antes de intentarlo.',
                icon: 'error',
                theme,
            })
            return
        }

        setIsSavingPartsColors(true)
        const updatedFormData = withManifoldEngine({ ...dataModelo3d, partColors3d: partsColors })
        try {
            editor.takeSnapshot()
            // El guardado desde 3D no debe desagrupar ni alterar el canvas 2D.
            // Serializamos primero el JSON y usamos la exportación SVG normal.
            const json2d = editor.saveJSON()
            const svg2d = editor.saveSVG()
            const response = await axios.put(`customized-keyrings/${currentModelId}/`, {
                svg_2d: svg2d,
                json_2d: json2d,
                name: modelo3dRef.current.name,
                form2d_data: updatedFormData,
            })
            skipNextParamsSaveRef.current = true
            setDataModelo3d(updatedFormData)
            setSavedPartsColors(partsColors)
            setModelo3d(response.data)
            modelo3dRef.current = response.data
            // Guardar otros colores cambia el diseño, y el backend descarta el
            // 3D generado (render de la tarjeta incluido). Se regenera en
            // segundo plano sin recargar el visor: ya enseña estos colores, y
            // la geometría no cambia. Así la tarjeta no se queda sin miniatura.
            axios.post(`customized-keyrings/${currentModelId}/regenerate-3d/`, {
                form2d_data: updatedFormData,
            }).catch(error => console.error('Error regenerating 3D after saving colors:', error))
            showAlert({
                title: 'Colores guardados',
                icon: 'success',
                timer: 900,
                showConfirmButton: false,
                position: 'top-start',
                width: '220px',
                theme,
            })
        } catch (error) {
            console.error('Error saving 3D part colors:', error)
            showAlert({
                title: 'No se pudieron guardar los colores',
                text: 'Inténtalo de nuevo.',
                icon: 'error',
                theme,
            })
        } finally {
            setIsSavingPartsColors(false)
        }
    }

    const selectedType = useSelectedTypeContext()
    const setSelectedType = useSelectedTypeToggleContext()
    const selectedTypeRef = useRef(selectedType)
    const navigate = useNavigate();
    const theme = getThemeContext();

    useEffect(() => {
        selectedTypeRef.current = selectedType
    }, [selectedType])


    const [modelo3d, setModelo3d] = useState({});
    const modelo3dRef = useRef(modelo3d);

    // Estado de guardado: 'saved' | 'dirty' | 'saving' | 'error'. Se comunica
    // desde el botón de guardar; guardar dejó de ser un evento que interrumpe.
    const [saveStatus, setSaveStatus] = useState('saved')
    // Preferencia del usuario, no del diseño. Apagada por defecto: guardar sigue
    // siendo cosa del botón o de Ctrl+S salvo que se pida lo contrario.
    const [autoSaveEnabled, toggleAutoSave] = useAutoSavePreference()
    // Cargar un diseño dispara los mismos eventos de fabric que editarlo: sin
    // esta marca, todo diseño nacería "sin guardar".
    const isLoadingDesignRef = useRef(true)
    // Evita que el autoguardado y un guardado manual se pisen.
    const savingRef = useRef(false)
    // Guardado en vuelo. Los que llegan mientras tanto se encolan detrás en vez
    // de rendirse: quien pide guardar (entrar en 3D, pedir el diseño, salir)
    // necesita un modelo de verdad, y devolverle null se leía como un fallo.
    const inFlightSaveRef = useRef(null)
    // Contador de ediciones. Guardar lee el lienzo en un instante concreto: si
    // el usuario sigue dibujando mientras el PUT viaja, el contador habrá
    // cambiado al volver y el diseño vuelve a quedar "sin guardar" en vez de
    // anunciarse guardado con cambios que no se enviaron.
    const dirtySeqRef = useRef(0)
    // Id que acabamos de crear nosotros. Al navegar a /<producto>/<id> cambia
    // `modelId`, y eso reengancha el efecto de carga: haría un GET y un
    // loadJSON que reconstruyen el lienzo que el usuario tiene delante (y le
    // borran la selección). El diseño ya está en memoria, así que se salta.
    const selfCreatedIdRef = useRef(null)
    const markDirty = useCallback(() => {
        if (isLoadingDesignRef.current) return
        // Guardar desagrupa el lienzo (`saveSVG(true)`) y el editor rehace los
        // grupos justo después. Ese vaivén no es una edición del usuario, y sin
        // ignorarlo el diseño salía "sin guardar" nada más guardarse.
        if (editorRef.current?.canvas?.__customiz3rRestoringGroups) return
        dirtySeqRef.current += 1
        setSaveStatus('dirty')
    }, [])

    const { editor, onReady, historyInfo } = useFabricJSEditor()

    // Ref para siempre tener el editor más reciente dentro del listener (evita stale closure)
    const editorRef = useRef(editor);
    useEffect(() => { editorRef.current = editor; }, [editor]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            // No actuar si el foco está en un input, textarea o elemento editable
            const activeEl = document.activeElement;
            if (
                activeEl?.tagName === 'INPUT' ||
                activeEl?.tagName === 'TEXTAREA' ||
                activeEl?.isContentEditable
            ) return;

            if (event.key === 'Delete') {
                editorRef.current?.deleteSelected();
            }
            // Flechas: mueven la selección 1 mm; con Shift 10 mm y con Alt
            // 0,1 mm. Solo en 2D, y solo se come la tecla si había algo que
            // mover, para no quitarle el scroll a la página.
            else if (NUDGE_DIRECTIONS[event.key] && !event.ctrlKey && !event.metaKey) {
                if (selectedTypeRef.current !== '2D') return;
                const step = event.shiftKey ? 10 : event.altKey ? 0.1 : 1;
                const [dx, dy] = NUDGE_DIRECTIONS[event.key];
                if (editorRef.current?.nudgeSelected?.(dx * step, dy * step)) event.preventDefault();
            }
            else if ((event.ctrlKey || event.metaKey) && !event.shiftKey && event.key.toLowerCase() === 'c') {
                event.preventDefault();
                editorRef.current?.copy2();
            }
            else if ((event.ctrlKey || event.metaKey) && !event.shiftKey && event.key.toLowerCase() === 'v') {
                event.preventDefault();
                editorRef.current?.paste2();
            }
            // Deshacer/rehacer con el mismo criterio que Figma/Sketch/Adobe/Google
            // Docs: Ctrl(Cmd)+Z deshace, Ctrl(Cmd)+Shift+Z rehace. Se añade
            // Ctrl+Y como alias de rehacer para quien viene de la costumbre de
            // Windows/Office — no pisa ningún otro atajo del editor.
            else if ((event.ctrlKey || event.metaKey) && !event.shiftKey && event.key.toLowerCase() === 'z') {
                event.preventDefault();
                editorRef.current?.undo();
            }
            else if (
                (event.ctrlKey || event.metaKey) &&
                (event.key.toLowerCase() === 'y' || (event.shiftKey && event.key.toLowerCase() === 'z'))
            ) {
                event.preventDefault();
                editorRef.current?.redo();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    //Para controlar el OrbitControls y poder mover de perspectiva la escena.
    // Se mira el producto, no la URL: la condición era
    // `pathname.startsWith("/customiz3r")`, que dejaba fuera a la caja de luz
    // (entonces en /lightbox). Con los nombres nuevos ambas rutas empiezan por
    // "/customiz3r", así que esa comprobación habría cambiado en silencio el
    // comportamiento del visor de la caja de luz.
    useEffect(() => {
        state.orbitControlActivation = product.key === 'keyring'
    });

    // Silueta guía de la servilleta en el lienzo (servilletero de paredes). Se
    // pinta en el editor y no se exporta; aquí solo se le pasa el tamaño.
    const napkinGuide = dataModelo3d?.panel
    useEffect(() => {
        if (!editor?.setNapkinGuide) return
        if (!product.roles?.napkinJoint) {
            editor.setNapkinGuide(null)
            return
        }
        editor.setNapkinGuide({
            widthMm: Number(napkinGuide?.napkinWidthMm) || 170,
            heightMm: Number(napkinGuide?.napkinHeightMm) || 110,
            fold: napkinGuide?.napkinFold === 'square' ? 'square' : 'triangle',
            tongueHeightMm: Number(napkinGuide?.tongueHeightMm) || 8,
            marginMm: Number(napkinGuide?.drawingMarginMm ?? 2),
            baseOverhangMm: Number(napkinGuide?.baseEndOverhangMm) || 0,
        })
    }, [editor, product.roles?.napkinJoint, napkinGuide?.napkinWidthMm, napkinGuide?.napkinHeightMm,
        napkinGuide?.napkinFold, napkinGuide?.tongueHeightMm, napkinGuide?.drawingMarginMm,
        napkinGuide?.baseEndOverhangMm])

    /**
     * Guarda el diseño. Única vía de persistencia del lienzo: antes había dos
     * copias casi idénticas (`onSave` y `saveCurrentModelForOrder`) que se
     * desincronizaban entre sí.
     *
     * Nunca pide el nombre: un diseño sin id se crea con el nombre por defecto
     * del producto y se renombra después desde el título de la barra superior.
     * Los errores se cuentan en el indicador de estado, nunca con un modal.
     */
    const runSave = async ({ silent = true, force = false } = {}) => {
        // En 3D el lienzo no es la fuente de verdad: devolvemos lo último
        // persistido en lugar de reescribirlo con un canvas que no se ha tocado.
        // `force` es para el salto 2D→3D, que guarda justo mientras la vista
        // cambia y todavía tiene el canvas 2D bueno delante.
        if (!editor?.canvas || (!force && selectedTypeRef.current !== '2D')) {
            return modelo3dRef.current?.id ? modelo3dRef.current : null
        }

        savingRef.current = true
        const savedSeq = dirtySeqRef.current
        setSaveStatus('saving')

        editor.takeSnapshot()
        const JSON_draw = editor.saveJSON()
        const currentModelId = modelo3dRef.current?.id

        try {
            const isUpdate = Boolean(currentModelId)
            const svgContent = isUpdate ? editor.saveSVG(true) : editor.saveSVG()
            const payload = {
                svg_2d: svgContent,
                json_2d: JSON_draw,
                // Un diseño nuevo puede haber sido renombrado antes de existir:
                // el nombre ya está en modelo3dRef aunque no haya id todavía.
                name: modelo3dRef.current?.name || buildDefaultDesignName(product),
                form2d_data: withManifoldEngine(dataModelo3d),
            }

            const response = isUpdate
                ? await axios.put(`customized-keyrings/${currentModelId}/`, payload)
                : await axios.post(`customized-keyrings/`, payload)

            setModelo3d(response.data)
            modelo3dRef.current = response.data

            if (!isUpdate) {
                // routeBase, no "/customiz3r": un diseño de lightbox debe
                // quedarse en su propia ruta. La marca evita que el cambio de
                // ruta recargue el diseño desde el backend.
                selfCreatedIdRef.current = String(response.data.id)
                navigate(`${product.routeBase}/${response.data.id}/`, { replace: true })
            }

            setSaveStatus(dirtySeqRef.current === savedSeq ? 'saved' : 'dirty')
            if (!silent) {
                toast.success(isUpdate ? 'Cambios guardados' : 'Diseño guardado', {
                    theme: theme === 'dark' ? 'dark' : 'light',
                    autoClose: 1600,
                })
            }
            return response.data
        } catch (error) {
            console.error('Error saving design:', error)
            setSaveStatus('error')
            if (!silent) {
                toast.error('No se pudo guardar el diseño', {
                    theme: theme === 'dark' ? 'dark' : 'light',
                })
            }
            return null
        } finally {
            savingRef.current = false
        }
    }

    /**
     * Guardar, en serie. Si ya hay un guardado en vuelo, este espera a que
     * termine y vuelve a guardar: así el segundo ve el id que creó el primero
     * (hace PUT, no otro POST) y siempre devuelve el modelo, nunca null por
     * estar ocupado.
     */
    const persistDesign = (options = {}) => {
        const previous = inFlightSaveRef.current
        const chained = (async () => {
            if (previous) {
                try { await previous } catch { /* el fallo ya lo contó quien guardaba */ }
            }
            return runSave(options)
        })()

        inFlightSaveRef.current = chained
        chained.finally(() => {
            if (inFlightSaveRef.current === chained) inFlightSaveRef.current = null
        })
        return chained
    }

    const handleManualSave = () => persistDesign({ silent: false })

    /**
     * Renombra el diseño desde el título de la barra superior.
     *
     * Sin id todavía, el nombre solo vive en el estado y viaja en el POST del
     * primer guardado. Con id, se persiste al momento y se actualiza también
     * `modelo3dRef`: el PUT de guardado lee el nombre de ahí, así que no
     * hacerlo devolvía el nombre viejo en el siguiente guardado.
     */
    const handleRenameDesign = async (newName) => {
        const currentModelId = modelo3dRef.current?.id

        if (!currentModelId) {
            const updated = { ...modelo3dRef.current, name: newName }
            setModelo3d(updated)
            modelo3dRef.current = updated
            setSaveStatus('dirty')
            return
        }

        try {
            await axios.post(`customized-keyrings/${currentModelId}/rename/`, { name: newName })
            const updated = { ...modelo3dRef.current, name: newName }
            setModelo3d(updated)
            modelo3dRef.current = updated
        } catch (error) {
            console.error('Error renaming design:', error)
            toast.error('No se pudo cambiar el nombre', {
                theme: theme === 'dark' ? 'dark' : 'light',
            })
            // Propagar deja que EditableTitle restaure el nombre anterior.
            throw error
        }
    }

    // Construye el GLB en el backend y, al terminar, refresca el visor.
    // Asume que la vista ya está (o se va a poner) en "3D" por el llamador.
    const regenerate3dFile = async (targetModelId) => {
        generationStartRef.current = performance.now()
        setGenerationDuration(null)
        setIsGeneratingFile(true)

        try {
            const response = await axios.post(`customized-keyrings/${targetModelId}/regenerate-3d/`, {
                form2d_data: withManifoldEngine(dataModelo3d),
            })
            const savedFormData = withManifoldEngine(response.data?.form2d_data || dataModelo3d)
            const updatedModel = {
                ...modelo3dRef.current,
                form2d_data: savedFormData,
            }

            setModelo3d(updatedModel)
            modelo3dRef.current = updatedModel
            setApplied3dParameters(get3dParameterSnapshot(savedFormData, product))

            // El archivo ya está listo: pasamos a la fase de carga del visor.
            setIsGeneratingFile(false)
            setIsViewerLoading(true)
            setViewerRevision(revision => revision + 1)
            return true
        } catch (error) {
            console.error('Error generating the 3D model:', error)
            setIsGeneratingFile(false)
            showAlert({
                title: 'No se pudo generar el modelo 3D',
                text: error?.response?.data?.detail || 'Revisa el diseño e inténtalo de nuevo.',
                icon: 'error',
                theme: theme,
            })
            return false
        }
    }

    // Botón "3D": cambia a la vista 3D de inmediato (mostrando el estado de
    // generación) y, en paralelo, guarda y genera el archivo.
    const handleEnter3d = async () => {
        setEditorTypeRight(prev => ({ ...prev, type: 'editor_params_3d' }))
        setSelectedType('3D')

        // Ya hay una generación en marcha (se salió a 2D mientras trabajaba):
        // volver a 3D solo enseña lo que ya está pasando. Lanzar una segunda
        // dejaría dos POST compitiendo por el mismo modelo.
        if (isRegenerating3d) return true

        setIsGeneratingFile(true)

        const savedModel = await persistDesign({ force: true })
        // Si el guardado falla pero el diseño ya existe, seguimos con lo último
        // persistido: enseñar un 3D algo desfasado es mejor que no enseñar nada,
        // y el indicador ya cuenta que hay cambios sin guardar.
        const targetId = savedModel?.id || modelo3dRef.current?.id
        if (!targetId) {
            // El diseño no llegó a crearse (fallo de red en el POST). Se avisa
            // y se sigue en 3D: pediste 3D, y devolverte a 2D descarta la
            // acción sin explicar nada.
            console.error('No se pudo crear el diseño antes de generar el 3D')
            setIsGeneratingFile(false)
            toast.error('No se pudo guardar el diseño; el 3D no se ha generado', {
                theme: theme === 'dark' ? 'dark' : 'light',
            })
            return false
        }

        return regenerate3dFile(targetId)
    }

    // Botón "Actualizar modelo 3D" (barra izquierda) tras tocar grosor/profundidad.
    const handleApply3dChanges = async () => {
        const currentModelId = modelo3dRef.current?.id
        if (!currentModelId || isRegenerating3d) return

        // Regenerar reconstruye a partir del SVG *guardado*, y la profundidad
        // por capa viaja precisamente en el SVG (ver `saveSVG` en editor.js).
        // Sin este guardado, tocar la profundidad de una capa y pulsar aquí no
        // hacía nada.
        if (saveStatus !== 'saved') await persistDesign({ force: true })

        await regenerate3dFile(currentModelId)
    }

    const handleViewerLoaded = () => {
        if (!isViewerLoading) return

        if (generationStartRef.current !== null) {
            setGenerationDuration(((performance.now() - generationStartRef.current) / 1000).toFixed(1))
            generationStartRef.current = null
        }
        setIsViewerLoading(false)
        showAlert({
            title: 'Modelo 3D actualizado',
            icon: 'success',
            timer: 1200,
            showConfirmButton: false,
            position: 'top-start',
            width: '240px',
            theme: theme,
        })
    }

    const handleViewerError = (error) => {
        console.error('Error loading generated GLB:', error)
        if (!isViewerLoading) return

        setIsViewerLoading(false)
        showAlert({
            title: 'No se pudo cargar el modelo 3D',
            text: 'El archivo se generó pero no pudo mostrarse. Inténtalo de nuevo.',
            icon: 'error',
            theme: theme,
        })
    }

    const handleRunManifoldPoc = async () => {
        if (!editor?.canvas || manifoldPocState.loading) return

        const svgContent = editor.saveSVG(true)
        if (!svgContent) {
            showAlert({
                title: 'No se pudo leer el SVG',
                text: 'Vuelve a la vista 2D y prueba otra vez.',
                icon: 'error',
                theme,
            })
            return
        }

        setManifoldPocState({ loading: true, result: null, error: null })
        try {
            const response = await axios.post('customized-keyrings/manifold-poc/', {
                svg_2d: svgContent,
                form2d_data: withManifoldEngine(dataModelo3d),
            })
            setManifoldPocState({
                loading: false,
                result: response.data,
                error: null,
            })
        } catch (error) {
            console.error('Error running Manifold PoC:', error)
            setManifoldPocState({
                loading: false,
                result: null,
                error: error?.response?.data?.detail || error?.message || 'No se pudo ejecutar Manifold.',
            })
        }
    }

    useEffect(() => {
        if (selectedType === '2D') {
            setIsGeneratingFile(false)
            setIsViewerLoading(false)
            // El panel de piezas solo tiene sentido en 3D; ciérralo al volver.
            setEditorTypeRight(prev => prev.type === 'editor_pieces_3d'
                ? { type: null, data: null }
                : prev)
        }
    }, [selectedType, setEditorTypeRight])

    const getSavedModelSnapshot = async () => {
        const currentModelId = modelo3dRef.current?.id;
        if (!currentModelId) return null;

        const response = await axios.get(`customized-keyrings/${currentModelId}/`);
        if (response.status === 200) {
            setModelo3d(response.data);
            modelo3dRef.current = response.data;
            return response.data;
        }

        return modelo3dRef.current;
    };

    /**
     * Modelo guardado y al día, para pedirlo o descargar el 3MF.
     * En 2D guarda el lienzo; en 3D basta con releer lo persistido.
     */
    const saveCurrentModelForOrder = async () => {
        if (selectedType !== "2D" || !editor?.canvas) {
            return getSavedModelSnapshot();
        }
        return persistDesign();
    };


    // Salida coreografiada: 1) HUD/toolbars fuera, 2) el lienzo 2D/3D se
    // desvanece dejando el fondo translúcido, 3) el fondo se hace transparente
    // y se navega al destino.
    const [isExiting, setIsExiting] = useState(false)

    const playExitAndNavigate = async () => {
        setIsExiting(true)

        if (document.startViewTransition) {
            // Fases 1-2 (HUD y lienzo); el cross-fade final hacia la página de
            // destino lo hace el navegador con la View Transitions API, que sí
            // muestra el destino apareciendo bajo el Customiz3r translúcido.
            await new Promise(resolve => setTimeout(resolve, 400))
            document.startViewTransition(() => {
                flushSync(() => navigate('/profile/general'))
            })
            return
        }

        // Fallback (Firefox antiguo, etc.): coreografía completa con fundido propio.
        await new Promise(resolve => setTimeout(resolve, 650))
        navigate('/profile/general')
    }

    // Sustituye la pose "animate" por la de salida cuando estamos saliendo,
    // reutilizando las variantes existentes de cada elemento del HUD.
    const hudMotion = (animation) => (
        isExiting ? { ...animation, animate: animation.exit } : animation
    )

    // Salida de Customiz3r con opción de guardar antes (usada por ESC y el menú).
    const exitPromptOpenRef = useRef(false)
    const handleExitCustomiz3r = async () => {
        if (exitPromptOpenRef.current) return

        // Con todo guardado no hay nada que preguntar: preguntar igualmente era
        // pedirle al usuario que decidiera sobre unos cambios que no existen.
        if (saveStatus === 'saved') {
            await playExitAndNavigate()
            return
        }

        exitPromptOpenRef.current = true

        try {
            const result = await showConfirm({
                title: 'Salir de Customiz3r',
                text: '¿Quieres guardar los cambios antes de salir?',
                icon: 'question',
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: 'Guardar y salir',
                denyButtonText: 'Salir sin guardar',
                cancelButtonText: 'Cancelar',
                theme: theme,
            })

            if (result.isConfirmed) {
                // saveCurrentModelForOrder guarda el lienzo en 2D y usa el último
                // estado persistido en 3D; devuelve null si el guardado falla.
                const savedModel = await saveCurrentModelForOrder()
                if (!savedModel?.id) return
                await playExitAndNavigate()
            } else if (result.isDenied) {
                await playExitAndNavigate()
            }
        } finally {
            exitPromptOpenRef.current = false
        }
    }

    const onChangeBaseLayout2 = async (textstring, options = {}) => {
        // const shape = event.target.value;
        console.log("textstring", textstring)
        const isBackendBaseLayout = textstring === 'offset' || textstring === 'fill';
        let data = null;

        setBaseLayoutActionState({
            loading: isBackendBaseLayout,
            action: isBackendBaseLayout ? textstring : null,
            error: null,
        })

        try {
            if (isBackendBaseLayout) {
                // Como dibujo se calcula sobre la selección (un borde alrededor
                // de un texto, por ejemplo); sin selección, sobre todo el diseño.
                const selection = options.asDrawing ? editor?.saveSelectionSVGForOffset() : null
                const currentSvg = selection?.svg ?? editor?.saveSVG(false, { forOffset: true })

                if (!currentSvg) {
                    throw new Error("No se pudo leer el SVG actual para calcular la forma.")
                }

                const response = await axios.put(`customized-keyrings/offset/`, {
                    svg: currentSvg,
                    offset: offsetLength,
                    type: textstring,
                    include_hole: Boolean(options.includeHole) && !options.asDrawing,
                    high_precision: Boolean(options.highPrecision),
                    offset_join_type: options.offsetJoinType || 'round',
                    background_inset: options.asDrawing ? 0 : Number(options.backgroundInset) || 0,
                    offset_drawings: Boolean(options.offsetDrawings),
                })

                data = {
                    svg: response?.data?.offseted_svg,
                    width: response?.data?.width,
                    height: response?.data?.height,
                }

                if (!data.svg) {
                    throw new Error("El backend no devolvio un SVG valido.")
                }

                if (options.asDrawing) {
                    // Un dibujo más: el fondo y sus medidas no se tocan.
                    await editor?.addOffsetDrawing(data.svg, selection?.objects ?? [])
                    setBaseLayoutActionState({ loading: false, action: null, error: null })
                    return;
                }

                await editor?.setBaseLayoutOffset(data.svg, data.width, data.height)
                if (data.width && data.height) {
                    // These dimensions describe the imported geometry. They are
                    // not a request to resize it in the dimension-change effect.
                    generatedBaseSize.current = { width: data.width, height: data.height }
                    setDataModelo3d({
                        baseLayout: {
                            ...dataModelo3d.baseLayout,
                            width: data.width,
                            height: data.height,
                            dimensionsUnit: 'mm',
                            key: textstring,
                            params: null,
                            offsetDrawings: Boolean(options.offsetDrawings),
                            drawingsOffsetMm: Boolean(options.offsetDrawings)
                                ? Number(offsetLength) - (Number(options.backgroundInset) || 0)
                                : 0,
                        },
                    })
                }

                setBaseLayoutActionState({ loading: false, action: null, error: null })
                return;
            }

            // Built-in shapes resolve through a lookup, so adding one no longer
            // means editing a switch here as well.
            data = buildBaseLayout(textstring, options.layoutParams);

            if (!data?.svg) return;

            if (data.width && data.height) {
                setDataModelo3d({
                    baseLayout: {
                        ...dataModelo3d.baseLayout,
                        width: data.width,
                        height: data.height,
                        dimensionsUnit: 'mm',
                        key: textstring,
                        params: data.params ?? null,
                    },
                })
            }

            editor?.setBaseLayout(data.svg, data.width, data.height)
        } catch (error) {
            console.error('Error changing base layout:', error);
            setBaseLayoutActionState({
                loading: false,
                action: null,
                error: getBaseLayoutErrorMessage(error),
            })
        }
    }

    /**********************CONTROL DEL MODAL**********************/
    const [isContentVisible, setIsContentVisible] = useState(false); // State to manage content visibility

    // Function to handle toggling the content visibility of MODAL
    const toggleContentVisibility = () => {
        setIsContentVisible(!isContentVisible);
    };

    //Para anadir un nuevo medio
    const [selectedMedio, setSelectedMedio] = useState(null);
    const handleMedioSelected = (card) => {
        setSelectedMedio(card);
    };

    useEffect(() => {

        if (selectedMedio) {
            console.log("selectedMedio", selectedMedio)
            editor?.addSVG(selectedMedio)
            toggleContentVisibility()
            // editor?.addImage(selectedMedio.url)
        }
    }, [selectedMedio]);

    /******************FIN DE CONTROL DEL MODAL******************/


    /****************** Fetching the modelo_3d at start ******************/
    useEffect(() => {
        if (!editor || String(modelId) === selfCreatedIdRef.current) return undefined

        // Poblar el lienzo (loadJSON o el layout inicial) dispara los mismos
        // eventos que editarlo. Fabric los emite de forma asíncrona, así que la
        // marca se libera un tick después de que el canvas se asiente; hasta
        // entonces `markDirty` los ignora y el diseño no nace "sin guardar".
        isLoadingDesignRef.current = true
        const settle = setTimeout(() => { isLoadingDesignRef.current = false }, 1200)
        return () => clearTimeout(settle)
    }, [modelId, editor]);

    useEffect(() => {
        // El id acaba de salir de nuestro propio POST: el estado ya está al día
        // (lo puso `persistDesign` con la respuesta) y el lienzo es justo el que
        // se guardó. Recargarlo aquí es lo que hacía "parpadear" el editor al
        // pasar de /customiz3r/ a /customiz3r/<id>.
        if (String(modelId) === selfCreatedIdRef.current) {
            selfCreatedIdRef.current = null
            return
        }

        console.log("holaaaaa")
        //Consultamos el modelo
        if(modelId && editor){
            console.log("fetching  " + modelId)
            // alert("fetching  " + modelId)
            axios.get(`customized-keyrings/${modelId}/`)
                .then(async response => {
                    if(response.status == 200){
                        const JSON_draw = response.data.json_2d; // Obtener el contenido SVG
                        const normalizedForm2dData = normalizePersistedBaseLayoutDimensions(
                            response.data.form2d_data,
                            JSON_draw,
                        )
                        await editor.loadJSON(JSON_draw)
                        const normalizedModel = {
                            ...response.data,
                            form2d_data: normalizedForm2dData,
                        }
                        setModelo3d(normalizedModel)
                        // Layer the stored data over the product's defaults:
                        // replacing the state outright would leave parameters
                        // added after this model was saved undefined, and the
                        // backend would have to guess. Stored values win.
                        const storedType = resolveProductType(normalizedForm2dData)
                        const merged = withManifoldEngine(withProductDefaults(normalizedForm2dData))
                        setDataModelo3d(merged)
                        setApplied3dParameters(get3dParameterSnapshot(merged, getProduct(storedType)))
                        modelo3dRef.current = normalizedModel
                        // Opening /lightbox/<id> on a keyring (or vice versa)
                        // must follow what was saved, not the URL.
                        if (storedType !== productType) {
                            navigate(`${getProduct(storedType).routeBase}/${modelId}/`, { replace: true })
                        }
                    }
                })
                .catch(error => {
                    console.error('Error fetching modelo:', error);
                    // 404 = no existe o no es tuyo (el backend nunca distingue
                    // las dos cosas, ver get_keyring_for_user_or_404). El
                    // efecto de arriba y este comparten clave de ruta
                    // (routeTransitionKey), así que el componente NO se
                    // remonta al cambiar de id: sin este reset, el lienzo/los
                    // refs seguirían mostrando el diseño propio cargado antes
                    // aunque la URL ya apunte a un id ajeno.
                    if (error?.response?.status === 404) {
                        editor?.deleteAll()
                        modelo3dRef.current = null
                        setModelo3d(null)
                        toast.error('Ese diseño no existe o no tienes acceso a él.')
                        navigate(product.routeBase, { replace: true })
                    }
                });
        }
        else{
            onChangeBaseLayout2(product.newModelLayout)
        }
    }, [modelId, editor]);



    /****************** END Fetching the model at start ******************/

    /****************** Para setear los parametros al inicio ******************/
    useEffect(() => {
        if (skipNextParamsSaveRef.current) {
            skipNextParamsSaveRef.current = false
            return
        }
        // Nunca escribir contra un id que no es el realmente cargado: si la
        // ruta apunta a un id ajeno/inexistente, `modelo3dRef.current` no
        // llegó a poblarse (o sigue siendo el diseño propio anterior, ver el
        // catch del efecto de carga) y su id no coincidirá con `modelId`.
        if(modelId && editor && selectedTypeRef.current === '2D' && String(modelo3dRef.current?.id) === String(modelId)){
            console.log("guardadon sizeee paramas", dataModelo3d.baseLayout)
            axios.put(`customized-keyrings/${modelId}/params/`,
                {
                    form2d_data: withManifoldEngine(dataModelo3d)
                })
                .then(() => {

                })
                .catch(error => {
                    console.error('Error fetching modelo:', error);
                });
        } else if (!modelId && editor) {
            // Diseño todavía sin crear: los parámetros no tienen dónde ir, así
            // que quedan pendientes hasta el primer guardado.
            markDirty()
        }
    }, [dataModelo3d]);
    /****************** END Para setear los parametros al inicio ******************/

    /****************** Autoguardado del lienzo 2D ******************/
    // Mismo patrón que el guardado de parámetros de arriba, pero con debounce:
    // el usuario deja de tocar el diseño y este se guarda solo. El primer
    // autoguardado de un diseño sin id es además el que lo crea y pone el id en
    // la URL, que es lo que antes exigía el modal de nombre.
    useEffect(() => {
        if (!autoSaveEnabled) return undefined
        if (saveStatus !== 'dirty' || selectedType !== '2D' || !editor) return undefined

        const timer = setTimeout(() => {
            // Si hay un guardado en vuelo no se encola otro: al terminar, el
            // contador de ediciones lo deja en "dirty" y este efecto vuelve.
            if (savingRef.current) return
            persistDesign({ silent: true })
        }, 2000)

        return () => clearTimeout(timer)
    }, [autoSaveEnabled, saveStatus, selectedType, editor]);
    /****************** FIN Autoguardado ******************/


    // Anchos reales de la barra izquierda y el panel derecho (cuando está
    // abierto), para que "Encuadrar dibujo" centre en el hueco visible en
    // vez de en el centro del canvas entero (que las tapa por encima).
    const leftDockRef = useRef(null)
    const rightPanelRef = useRef(null)

    /*** Triggers fabric.js events ***/
    const bindedSelectionRef = useRef(false)
    const [selectedObjects, setSelectedObjects] = useState()
    // El botón de esquinas redondeadas es contextual: aparece solo cuando hay
    // algún rectángulo del usuario seleccionado (el fondo se redondea desde
    // Base/Cuerpo, con su propio parámetro).
    const hasRectSelection = (selectedObjects || []).some(
        obj => obj?.type === 'rect' && !String(obj?.id || '').startsWith('background')
    )
    // Dropdown agrupar/desagrupar: contextual según qué hay seleccionado, no
    // solo cuántos objetos — con 1 objeto hace falta el `type` para distinguir
    // "un grupo" (Desagrupar) de "una forma suelta" (nada que hacer).
    const canGroup = (selectedObjects || []).length >= 2
    const canUngroup = (selectedObjects || []).length === 1 && selectedObjects[0].type === 'group'

    useEffect(()=> {
        console.log("selectedObjects", selectedObjects)

        // //En el caso de haber seleccionado solo un objeto y que sea de typo text se abrira el editor right, a text editor
        // if (selectedObjects && selectedObjects.length == 1 && selectedObjects[0].type == "text") {
        //     setEditorTypeRight({ ... editorTypeRight, type: "editor_text"})
        // }
        // //En el caso de no tener ningun elemento seleccionado si editorTypeRight es editor_text se cerrara
        // if (selectedObjects && selectedObjects.length == 0 && editorTypeRight == "editor_text") {
        //     setEditorTypeRight({ ... editorTypeRight, type: null})
        // }


    }, [selectedObjects]);

    useEffect(() => {
        if(editor && editor.canvas && !bindedSelectionRef.current){

            const isFocusInsideTextEditor = () => {
                const activeElement = document.activeElement;
                return Boolean(activeElement?.closest?.('[data-customiz3r-text-editor="true"]'));
            };
            const shouldKeepTextEditorOpen = () => (
                editorTypeRightRef.current?.type === "editor_text" &&
                (keyboardOpenRef.current || isFocusInsideTextEditor())
            );
            const isMultitouchGesture = () => Boolean(editor.canvas?.__customiz3rMultitouch);
            // A selection change caused by the editor replacing a shape on the
            // user's behalf (see `asInternalEdit` in fabricjs/editor.js), not by
            // the user clicking away. Closing the panel on those would shut the
            // panel the user is typing in.
            const isInternalEdit = () => Boolean(editor.canvas?.__customiz3rInternalEdit);
            // The hanging-slot panel tells the user to drag the markers around,
            // so dragging one must not close the panel out from under them.
            const isDraggingTechnicalMarker = () => (
                editorTypeRightRef.current?.type === 'editor_hole' &&
                (editor.getSelectedObjects() || []).some(
                    obj => String(obj?.id || '').startsWith('keyhole')
                        || String(obj?.id || '').startsWith('screw')
                        || String(obj?.id || '').startsWith('crocs_')
                        || String(obj?.id || '').startsWith('insert_')
                        || String(obj?.id || '').startsWith('silbato_')
                        || String(obj?.id || '').startsWith('abridor_')
                        || String(obj?.id || '').startsWith('abrelatas_')
                )
            );
            // El panel de esquinas redondeadas se lee mientras se toca el
            // propio rectángulo: al escalarlo cambia el radio máximo, y
            // cerrarlo ahí obligaría a reabrirlo tras cada ajuste.
            const isEditingRectShape = () => (
                editorTypeRightRef.current?.type === 'editor_shape' &&
                (editor.getSelectedObjects() || []).some(obj => obj?.type === 'rect')
            );
            const closeRightPanel = () => {
                setEditorTypeRight(prev => ({ ...prev, type: null, data: null }));
            };
            // Paneles que se abren y se cierran desde la barra izquierda, no
            // desde la selección: son herramientas, no el editor de lo que hay
            // seleccionado. Cerrarlos al deseleccionar echaba al usuario del
            // panel de capas justo al borrar algo desde él.
            const STICKY_PANELS = ['editor_base_layout', 'editor_layers', 'editor_history', 'editor_pieces_3d', 'editor_hole', 'editor_offset_drawing'];

            editor.bindEvent('selection:cleared', (e) => {
                setSelectedObjects(editor.getSelectedObjects())
                if(!STICKY_PANELS.includes(editorTypeRightRef.current?.type) && !shouldKeepTextEditorOpen() && !isMultitouchGesture() && !isInternalEdit()){
                    closeRightPanel()
                }
                // //En el caso de no tener ningun elemento seleccionado si editorTypeRight es editor_text se cerrara
                // if (selectedObjects_aux && selectedObjects_aux.length == 0 && editorTypeRight.type == "editor_text") {
                // }
            });
            // El editor de texto ya no se abre solo al seleccionar (ni desde el
            // lienzo ni desde el panel de capas): siempre hace falta el botón
            // de "cambiar fuente" junto al zoom (TextEditButton.jsx). Antes se
            // abría también al tocar el texto en el lienzo, pero eso hacía que
            // elegirlo desde las capas para moverlo o borrarlo abriera el panel
            // de encima sin que nadie lo pidiera.
            editor.bindEvent('selection:created', () => {
                var selectedObjects_aux = editor.getSelectedObjects()
                console.log("selection:created", selectedObjects_aux)
                setSelectedObjects(selectedObjects_aux)
            });
            editor.bindEvent('selection:updated', () => {
                var selectedObjects_aux = editor.getSelectedObjects()
                console.log("selection:updated",selectedObjects_aux)
                setSelectedObjects(selectedObjects_aux)
            });
            editor.bindEvent('object:moving', () => {
                console.log('moviing')
                var selectedObjects_aux = editor.getSelectedObjects()
                //Cuando estamos moviendo el objeto de texto hacemos que se quite el editor de la decha.
                if (selectedObjects_aux && selectedObjects_aux.length > 0 && !shouldKeepTextEditorOpen() && !isMultitouchGesture() && !isDraggingTechnicalMarker() && !isEditingRectShape()) {
                    closeRightPanel()
                }
                setSelectedObjects(selectedObjects_aux)
            });
            editor.bindEvent('object:scaling', () => {
                var selectedObjects_aux = editor.getSelectedObjects()
                //Cuando estamos moviendo el objeto de texto hacemos que se quite el editor de la decha.
                if (selectedObjects_aux && selectedObjects_aux.length > 0 && !shouldKeepTextEditorOpen() && !isMultitouchGesture() && !isEditingRectShape()) {
                    closeRightPanel()
                }
            });
            // Cualquier cambio real del lienzo pasa por aquí: es lo que enciende
            // el "sin guardar" y, tras el debounce, el autoguardado.
            // `layer:changed` (color) y `layer:reordered` (z-index) no pasan por
            // los eventos de objeto de fabric, así que sin ellos un cambio de
            // color o de orden se quedaba sin marcar y, con el autoguardado
            // apagado, se perdía al salir.
            const dirtyEvents = [
                'object:added', 'object:modified', 'object:removed', 'path:created',
                'layer:changed', 'layer:reordered',
            ];
            dirtyEvents.forEach(eventName => editor.bindEvent(eventName, markDirty));
            bindedSelectionRef.current = true;
        }
    }, [editor]);
    /*** END Triggers fabric.js events ***/









    useEffect((e) => {
        //show e

        // console.log('dataModelo3ddddd WIIIDHTtttttt', dataModelo3d.baseLayout);
        const includeDrawings = nextBaseSizeResizeIncludesDrawings.current
        nextBaseSizeResizeIncludesDrawings.current = false
        const generated = generatedBaseSize.current
        generatedBaseSize.current = null
        if (generated && Number(dataModelo3d.baseLayout.width) === generated.width
            && Number(dataModelo3d.baseLayout.height) === generated.height) return
        editor?.setSizeLayout(
            String(dataModelo3d.baseLayout.width),
            String(dataModelo3d.baseLayout.height),
            { includeDrawings },
        );

    }, [dataModelo3d.baseLayout.width, dataModelo3d.baseLayout.height]);





    /*** Controlar los COMANDOS, HOTKEYS u otros ***/

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                // Con el modal de medios abierto, ESC solo lo cierra.
                if (isContentVisible) {
                    setIsContentVisible(false);
                    return;
                }

                // No interferir mientras se escribe en un input/textarea.
                const activeEl = document.activeElement;
                if (
                    activeEl?.tagName === 'INPUT' ||
                    activeEl?.tagName === 'TEXTAREA' ||
                    activeEl?.isContentEditable
                ) return;

                handleExitCustomiz3r();
            }
            // Ctrl/Cmd + S guarda, en vez de abrir el "guardar página" del navegador.
            else if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 's') {
                event.preventDefault();
                handleManualSave();
            }
            // Si presionamos Alt + Shift + I, se abre el importador
            else if (event.altKey && event.shiftKey && event.key.toLowerCase() === 'i') {
                setIsContentVisible(true);

            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    });

    /*** FIN Controlar los COMANDOS, HOTKEYS u otros ***/


    return (


            <ToolProvider editor={editor} historyInfo={historyInfo}>
                <motion.div
                    className="absolute z-40 top-5 right-5"
                    {...hudMotion(fadeAnimation)}
                >
                    {/*<div*/}
                    {/*    className="flex items-center justify-center w-10 h-10 rounded-md bg-gray-700 text-sm font-bold text-white border-2 border-transparent hover:border-amber-100 hover:bg-gray-600 transition"*/}
                    {/*    onClick={handleSalirCustomiz3r}*/}
                    {/*    style={{ textDecoration: 'none' }}*/}
                    {/*>*/}
                    {/*    <IconHome className="w-6 h-6" />*/}

                    {/*</div>*/}
                    <div className="flex items-center gap-2 rounded-box bg-base-100/80 px-2 py-1 backdrop-blur">
                        {/* El nombre y el estado de guardado viven juntos y
                            siempre visibles: renombrar dejó de estar escondido
                            en el menú y guardar dejó de ser un evento. */}
                        <EditableTitle
                            value={modelo3d?.name}
                            onCommit={handleRenameDesign}
                            placeholder="Diseño sin título"
                        />
                        <ToolsActionsGeneral
                            modelo3d={modelo3d}
                            setModelo3d={setModelo3d}
                            onSaveForOrder={saveCurrentModelForOrder}
                            onSaveForDownload={selectedType === "2D" ? saveCurrentModelForOrder : undefined}
                            onExit={handleExitCustomiz3r}
                            onSave={handleManualSave}
                            saveStatus={saveStatus}
                            selectedType={selectedType}
                            autoSaveEnabled={autoSaveEnabled}
                            onToggleAutoSave={toggleAutoSave}
                        />
                    </div>

                </motion.div>
                <motion.div
                    className="wrapperCustomizer"
                    animate={isExiting
                        ? { opacity: 0, transition: { duration: 0.25, delay: 0.35, ease: 'easeIn' } }
                        : { opacity: 1 }}
                >

                    <div className="min-w-full min-h-full h-screen bg-neutral z-10 customiz3r-canvas-stage">
                        <motion.div
                            className="relative w-full h-full"
                            animate={isExiting
                                ? { opacity: 0, scale: 0.96, transition: { duration: 0.3, delay: 0.1, ease: 'easeIn' } }
                                : { opacity: 1, scale: 1 }}
                        >
                        {/* FabricJS debe permanecer montado al entrar en 3D. Si se
                            desmonta, canvas.dispose() vacía la instancia que usa el
                            guardado de colores y termina sobrescribiendo el modelo. */}
                        <div
                            className={`absolute inset-0 ${selectedType === '2D'
                                ? 'visible opacity-100 pointer-events-auto'
                                : 'invisible opacity-0 pointer-events-none'}`}
                            aria-hidden={selectedType !== '2D'}
                        >
                            <FabricJSCanvas
                                className={`sample-canvas min-h-full min-w-full h-full ${theme === 'dark' ? 'bg-[#444] bg-opacity-100' : 'bg-neutral bg-opacity-100'}`}
                                onReady={onReady}
                            />
                        </div>
                        {selectedType === "3D" && (
                            <div className="absolute inset-0 min-w-full min-h-full h-full w-full">
                                {/* Se monta desde que se entra en 3D, no cuando
                                    hay archivo: con revisión 0 el visor pinta
                                    la escena vacía (grid, luces, cámara) y así
                                    la generación transcurre sobre el estudio en
                                    vez de sobre un fondo liso. */}
                                <Viewer2
                                    key={`${modelo3d?.id || modelId}-${viewerRevision}`}
                                    modelId={modelo3d?.id || modelId}
                                    revision={viewerRevision}
                                    onLoaded={handleViewerLoaded}
                                    onError={handleViewerError}
                                    onPartsLoaded={handlePartsLoaded}
                                    partsVisibility={partsVisibility}
                                    partsColors={partsColors}
                                    partsLayout={partsLayout}
                                    separationMm={separationMm}
                                    sectionEnabled={sectionEnabled}
                                    sectionHeightPct={sectionHeightPct}
                                    sectionKeep={sectionKeep}
                                    gridVisible={isGridVisible3d}
                                    orientation={viewOrientation3d}
                                    cameraPoseRef={viewerCameraPoseRef}
                                    className="bg-[color-mix(in_oklch,oklch(var(--b3)),black_12%)]"
                                />

                                <ARViewer
                                    modelId={modelo3d?.id || modelId}
                                    revision={viewerRevision}
                                    direct
                                />

                                {generationDuration !== null && !isRegenerating3d && (
                                    <div className="absolute bottom-2 left-2 z-30 rounded px-2 py-1 text-xs font-mono pointer-events-none"
                                        style={{ background: 'rgba(0,0,0,0.45)', color: '#fff' }}>
                                        gen: {generationDuration}s
                                    </div>
                                )}
                            </div>
                        )}
                        </motion.div>
                    </div>

                    {selectedType === "2D" && !isExiting && (
                        <ViewportDock leftDockRef={leftDockRef} rightPanelRef={rightPanelRef} />
                    )}

                    {shouldShowPortraitNotice && (
                        <div className="customiz3r-orientation-overlay">
                            <div className="customiz3r-orientation-card">
                                <h2>Gira el móvil</h2>
                                <p>Para editar el diseño con precisión, usa el móvil en horizontal.</p>
                                <Link className="btn btn-primary btn-sm" to="/profile/general">
                                    Salir
                                </Link>
                            </div>
                        </div>
                    )}


                    {/*<motion.div*/}
                    {/*    key="customTop"*/}
                    {/*    className="absolute z-50 top-0 left-0 w-full flex justify-center bg-yellow-200" // Using flexbox to center horizontally*/}
                    {/*    {...slideAnimation('right')}*/}
                    {/*>*/}
                    {/*    <ToolSelectorTop*/}
                    {/*        // setEditorTypeRight={setEditorTypeRight}*/}
                    {/*        toggleContentVisibility={toggleContentVisibility}*/}
                    {/*        onSave={onSave}*/}
                    {/*        modelId={modelId}*/}
                    {/*    />*/}
                    {/*</motion.div>*/}

                    <motion.div
                        key="customTop"
                        className="absolute z-50 top-0 left-[160px] w-[calc(100%-300px)] flex justify-center"
                        {...hudMotion(slideAnimation('right'))}
                    >
                        <ToolSelectorTop
                            product={product}
                            toggleContentVisibility={toggleContentVisibility}
                            onEnter3d={handleEnter3d}
                            modelId={modelId}
                            hasPending3dChanges={!are3dParametersEqual(
                                applied3dParameters,
                                get3dParameterSnapshot(dataModelo3d, product),
                            )}
                            isRegenerating3d={isRegenerating3d}
                            regenerationPhase={regenerationPhase}
                        />
                    </motion.div>

                    <motion.div
                        key="customLeft"
                        ref={leftDockRef}
                        className="absolute top-0 left-0 z-40 h-screen"
                        {...hudMotion(slideAnimation('left'))}
                    >
                        <div className="flex items-center p-2 h-full">
                            <LeftToolbar>
                                <ToolSelectorLeft
                                    modelID={modelo3d?.id || modelId}
                                    onApply3dChanges={handleApply3dChanges}
                                    hasPending3dChanges={!are3dParametersEqual(
                                        applied3dParameters,
                                        get3dParameterSnapshot(dataModelo3d, product),
                                    )}
                                    isRegenerating3d={isRegenerating3d}
                                    hasRectSelection={hasRectSelection}
                                    selectedCount={(selectedObjects || []).length}
                                    canGroup={canGroup}
                                    canUngroup={canUngroup}
                                    isGridVisible3d={isGridVisible3d}
                                    onToggleGrid3d={() => setIsGridVisible3d((visible) => !visible)}
                                    viewOrientation3d={viewOrientation3d}
                                    onViewOrientation3dChange={setViewOrientation3d}
                                />
                            </LeftToolbar>
                        </div>
                    </motion.div>



                    {
                        editorTypeRight.type &&

                        <motion.div
                            key="customRight"
                            ref={rightPanelRef}
                            className="absolute bottom-0 right-0 w-1/3 pr-3 z-10 max-h-[90vh] min-h-[80vh] h-[80vh] pb-6"
                            {...hudMotion(slideAnimation('right'))}
                        >
                            <div className="min h-full   min-h-full">
                                <div className="editortabs-container min-w-full w-full h-full" >
                                    <ToolSelectorRight
                                        product={product}
                                        onChangeBaseLayout={onChangeBaseLayout2}
                                        baseLayoutActionState={baseLayoutActionState}
                                        resizeDrawingsWithBase={resizeDrawingsWithBase}
                                        onResizeDrawingsWithBaseChange={setResizeDrawingsWithBase}
                                        onBaseSizeSliderChange={() => {
                                            nextBaseSizeResizeIncludesDrawings.current = resizeDrawingsWithBase
                                        }}
                                        manifoldPoc={{
                                            state: manifoldPocState,
                                            onRun: handleRunManifoldPoc,
                                            onClose: () => setManifoldPocState({ loading: false, result: null, error: null }),
                                        }}
                                        parts3d={{
                                            parts: modelParts,
                                            visibility: partsVisibility,
                                            onToggle: togglePartVisibility,
                                            onShowAll: showAllParts,
                                            onSolo: soloPart,
                                            colors: partsColors,
                                            onColorChange: changePartColor,
                                            onGroupColorChange: changePartsColor,
                                            onSaveColors: savePartsColors,
                                            hasColorChanges: !areColorMapsEqual(partsColors, savedPartsColors),
                                            isSavingColors: isSavingPartsColors,
                                            // Only offer the open view when the product
                                            // actually has a second piece to lift off.
                                            canExplode: hasSeparableParts(modelParts),
                                            partsLayout,
                                            onPartsLayoutChange: setPartsLayout,
                                            separationMm,
                                            onSeparationChange: setSeparationMm,
                                            // El corte no depende del producto: vale
                                            // igual para el llavero que para la caja
                                            // de luz, así que no lleva gate alguno.
                                            sectionEnabled,
                                            onSectionEnabledChange: setSectionEnabled,
                                            sectionHeightPct,
                                            onSectionHeightChange: setSectionHeightPct,
                                            sectionKeep,
                                            onSectionKeepChange: setSectionKeep,
                                        }}
                                    />
                                </div>
                            </div>
                        </motion.div>
                    }

                </motion.div>




                {/* Modal */}

                {/* Other components */}
                {isContentVisible && (

                    <motion.div
                        className="fixed top-0 left-0 flex justify-center items-center z-50 h-screen w-screen py-5 px-8"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <div className="relative glassCard p-4  w-full h-full ">
                            <button
                                className="absolute top-0 right-0 p-2 text-white z-20"
                                onClick={() => {
                                    toggleContentVisibility()
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </button>


                            <ExploradorMedios  onMedioSelect={handleMedioSelected}   />
                        </div>
                    </motion.div>
                )}
                {/* END Modal */}
            </ToolProvider>


    );
}






export default Customizer;
